// extracted by mini-css-extract-plugin
export default {"button":"DownloadButton_button__VPIuN"};